import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-notificacion',
  templateUrl: './modal-notificacion.component.html',
  styleUrls: ['./modal-notificacion.component.scss'],
})
export class ModalNotificacionComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ModalNotificacionComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      description: string;
      confirmText?: string;
      cancelText?: string;
      classDialog?: string;
      showCancel?: boolean;
    },
  ) {}

  ngOnInit() {
    console.log('a');
  }

  onConfirm(): void {
    this.dialogRef.close({
      accion: 'confirmar',
    });
  }

  onCancel(): void {
    this.dialogRef.close({ accion: 'cancelar' });
  }

  onClose(): void {
    this.dialogRef.close({ accion: 'cerrar' });
  }
}
